<template>
  <header class="br-page-header" :class="{ 'br-page-header--bordered': bordered }">
    <div class="br-page-header__main">
      <div v-if="$slots.leading" class="br-page-header__leading">
        <slot name="leading" />
      </div>
      <div class="br-page-header__content">
        <h1 class="br-page-header__title">{{ title }}</h1>
        <p v-if="subtitle" class="br-page-header__subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div v-if="$slots.actions" class="br-page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageHeader",

  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    bordered: { type: Boolean, default: false },
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/design-system/tokens";

.br-page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: $br-space-3 $br-space-4;
  margin-bottom: $br-space-4;
}

.br-page-header--bordered {
  padding-bottom: $br-space-4;
  border-bottom: 1px solid $br-border-soft;
}

.br-page-header__main {
  display: flex;
  align-items: flex-start;
  gap: $br-space-3;
  flex: 1 1 200px;
  min-width: 0;
}

.br-page-header__leading {
  flex-shrink: 0;
  padding-top: 2px;
}

.br-page-header__title {
  font-size: 1.45rem;
  font-weight: 800;
  color: $br-ink-soft;
  letter-spacing: -0.2px;
  margin: 0;
  line-height: 1.25;
}

.br-page-header__subtitle {
  margin: $br-space-1 0 0;
  font-size: $br-font-size-md;
  color: $br-muted;
  font-weight: 500;
  line-height: 1.4;
}

.br-page-header__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: $br-space-2;
  flex-shrink: 0;
}

@media (max-width: 599px) {
  .br-page-header__actions {
    width: 100%;
    justify-content: stretch;

    ::v-deep .v-btn {
      flex: 1 1 auto;
    }
  }
}
</style>
